export const UPDATE_AUTH_TOKEN_ACTION = 'auth/updateToken'
export const UPDATE_TICKERS_ACTION = 'leverage/updateTickers'
